import { reactive } from 'vue'
import actions from '@/store/screen/actions'
import state from '@/store/screen/state'
import getters from '@/store/screen/getters'

export const screenModule = reactive({
    state,
    actions,
    getters,
})
